import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import { AddButton, DeleteButton } from 'components/core';
import { ClientDialog, TaxCategoryDialog } from 'components/admin/Dialogs';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  marginBottom: {
    marginBottom: theme.spacing.unit*2,
  },
  addRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  formControl: {
    width: '230px',
    margin: '0px',
    marginRight: theme.spacing.unit*2,
  },
});

class Cogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddClient: false,
      showAddTaxCategory: false,
    };
  }

  render() {
    const {
      classes,
      clients,
      showValidation,
      validation,
      receipt,
      taxCategories,
      projects,
      handleChange
    } = this.props;
    const { showAddClient, showAddTaxCategory } = this.state;

    return(
      <div className={classes.root}>
        <ClientDialog
          show={showAddClient}
          handleCreated={(result) => {
            handleChange("clientId", result);
          }}
          handleClose={() => this.setState({ showAddClient: false })}
        />
        <TaxCategoryDialog
          show={showAddTaxCategory}
          handleCreated={(result) => {
            handleChange("taxCategoryId", result);
          }}
          handleClose={() => this.setState({ showAddTaxCategory: false })}
        />
        <div className={classes.addRow}>
          <FormControl
            error={(showValidation && !!validation.validateField("clientId"))}
            className={classes.formControl}
          >
            <InputLabel htmlFor="client-simple">Client</InputLabel>
            <Select
              value={receipt.clientId === undefined ? "" : receipt.clientId}
              onChange={(event) => {
                handleChange("clientId", event.target.value);
              }}
              inputProps={{
                name: 'clientId',
                id: 'client-simple',
              }}
            >
              {clients &&
                clients.map((client, i) => {
                  return <MenuItem key={i} value={client.id}>{`${client.lastName}, ${client.firstName}`}</MenuItem>
                })
              }
            </Select>
            {showValidation && validation.validateField("clientId") &&
               <FormHelperText>{validation.validateField("clientId")}</FormHelperText>
             }
          </FormControl>
          <AddButton
            onClick={() => this.setState({ showAddClient: true })}
          />
        </div>
        <div className={classes.addRow}>
          <FormControl
            className={classes.formControl}
          >
            <InputLabel htmlFor="client-simple">Job (optional)</InputLabel>
            <Select
              value={receipt.projectId === undefined ? "" : receipt.projectId}
              onChange={(event) => {
                handleChange("projectId", event.target.value);
              }}
              inputProps={{
                name: 'jobId',
                id: 'job-simple',
              }}
            >
              {projects &&
                projects.map((project, i) => {
                  return <MenuItem key={i} value={project.id}>{project.jobCode}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <DeleteButton
            onClick={() => handleChange("projectId", null)}
          />
        </div>
        <div className={classes.addRow}>
          <FormControl
            error={(showValidation && !!validation.validateField("taxCategoryId"))}
            className={classes.formControl}
          >
            <InputLabel htmlFor="taxCategory-simple">Tax Category</InputLabel>
            <Select
              value={receipt.taxCategoryId === undefined ? "" : receipt.taxCategoryId}
              onChange={(event) => {
                handleChange("taxCategoryId", event.target.value);
              }}
              inputProps={{
                name: 'taxCategoryId',
                id: 'taxCategory-simple',
              }}
            >
              {taxCategories &&
                taxCategories.map((taxCategory, i) => {
                  return <MenuItem key={i} value={taxCategory.id}>{taxCategory.name}</MenuItem>
                })
              }
            </Select>
            {showValidation && validation.validateField("taxCategoryId") &&
               <FormHelperText>{validation.validateField("taxCategoryId")}</FormHelperText>
             }
          </FormControl>
          <AddButton
            onClick={() => this.setState({ showAddTaxCategory: true })}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { receipt } = props;
  const clients = state.clientsState;
  const taxCategories = state.taxCategoriesState;
  const client = clients.find(client => client.id === receipt.clientId);
  const projects = client && state.projectsState.filter(project => client.id === project.clientId);


  return {
    clients: clients,
    taxCategories: taxCategories,
    projects: projects,
  }
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(Cogs);



// WEBPACK FOOTER //
// ./src/components/admin/Receipts/Dialog/Cogs.jsx